import { chakra, shouldForwardProp } from '@chakra-ui/react'
import { AnimatePresence, isValidMotionProp, motion } from 'framer-motion'

import { INCIDENT_DRAWER_WIDTH } from '../shared/constants/drawerDimensions'

// Re-exported for the existing importers; shared/constants is the source.
export { INCIDENT_DRAWER_WIDTH }

/**
 * Allow motion props and non-Chakra props to be forwarded.
 */
const MotionBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
})

interface IncidentDrawerContainerIProps {
  children?: React.ReactNode
  bgColor?: string
  borderColor?: string
  dataTestid?: string
  width: number
}

export const IncidentDrawerContainer = ({
  children,
  bgColor = 'white',
  borderColor,
  dataTestid,
  width,
}: IncidentDrawerContainerIProps) => {
  return (
    <AnimatePresence>
      <MotionBox
        animate={{ right: INCIDENT_DRAWER_WIDTH }}
        backgroundColor={bgColor}
        border={borderColor ? '1px solid' : undefined}
        borderColor={borderColor}
        boxShadow='inset -6px 0 15px -6px rgba(0,0,0,0.15)'
        data-testid={dataTestid}
        display='flex'
        exit={{ right: 0 }}
        flexDirection='column'
        h='100vh'
        initial={{ right: 0 }}
        maxW={`${width}px`}
        overflow='hidden'
        position='absolute'
        top='0'
        // Reference: https://chakra-ui.com/getting-started/with-framer
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        transition={{ duration: 0.1, ease: 'easeInOut' }}
        w={width}
        zIndex={-1}
      >
        {children}
      </MotionBox>
    </AnimatePresence>
  )
}
